import { Box, Typography } from '@mui/material'

import { Maybe, UserDeliveryInfoFragment } from '@/clients/utoniq-core/schema'
import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import { StoreDeliveryInfoForm } from './StoreDeliveryInfoForm'

export * from './fragments'

export type State = {
  user: Maybe<UserDeliveryInfoFragment>
}

export type Action = {
  onSubmit: (value: {
    postalCode: string
    prefecture: string
    city: string
    line1: string
    line2?: Maybe<string>
  }) => Promise<void>
}

export const StoreDeliveryInfoTemplate: Template<State, Action> = ({
  state,
  onSubmit,
}) => {
  const { t } = useTranslation('storeDeliveryInfo')
  const { routerNames } = useRouter()
  return (
    <BaseLayout
      margin
      header={{
        title: t('title'),
        back: true,
      }}
    >
      <Head title={routerNames.StoreDeliveryInfo} />
      <Box>
        <Typography variant="subtitle1" sx={{ py: 2 }}>
          {t('label')}
        </Typography>
      </Box>
      <StoreDeliveryInfoForm
        onSubmitSetting={onSubmit}
        deliveryInfo={state.user || {}}
        // don't need anything action
        onClose={() => {}}
      />
    </BaseLayout>
  )
}
